import { t } from '../../../locales';
import CreateProductButton from './pages/products-list/components/header-btn.vue';
import { useAuthStore } from '../../store/shared/auth-store';
import { supportedMarketplaces } from './entities/repricing-rule';
import CreateRuleButton from './pages/repricing-rules/list/components/create-rule-button.vue';
import { featureFlag } from '../../entities/feature-flag';
import { abilities, useLimitationsStore } from './stores/limitations';

const productsModuleRoutes = {
	path: 'products',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.E_COMMERCE,
	},
	children: [
		{
			path: 'link-variants/:productId',
			component: () => import('./pages/link-variants/index.vue'),
			meta: {
				title: t('products.linkVariants'),
			},
		},
		{
			path: 'linked-variants/:linkedMarketplaceId',
			component: () => import('./pages/linked-variants/index.vue'),
			props: true,
			meta: {
				title: t('products.products-management'),
			},
		},
		{
			path: 'product-in-marketplaces/:productId',
			component: () => import('./pages/manage-product-in-marketplaces/index.vue'),
			props: true,
			meta: {
				title: t('products.manage-in-marketplaces'),
			},
		},
		{
			path: 'auto-link',
			component: () => import('./pages/auto-link/index.vue'),
			meta: {
				title: t('products.auto-link-products'),
			},
		},
		{
			path: 'list',
			component: () => import('./pages/products-list/index.vue'),
			meta: {
				title: t('products.products'),
				headerExtraComponent: CreateProductButton,
			},
		},
		{
			path: 'repricing-rules/list',
			component: () => import('./pages/repricing-rules/list/index.vue'),
			meta: {
				headerExtraComponent: CreateRuleButton,
				title: t('products.repricing-tool'),
				can: () => {
					const authStore = useAuthStore();
					return (
						authStore.availableMarketplaces.filter((marketplace) =>
							supportedMarketplaces.includes(marketplace.id),
						).length > 0
					);
				},
			},
		},
		{
			path: 'repricing-rules/create',
			component: () => import('./pages/repricing-rules/create-edit/index.vue'),
			meta: {
				title: t('products.create-repricing-rule'),
				can: () => {
					const authStore = useAuthStore();
					return (
						authStore.availableMarketplaces.filter((marketplace) =>
							supportedMarketplaces.includes(marketplace.id),
						).length > 0
					);
				},
			},
		},
		{
			path: 'repricing-rules/:id',
			component: () => import('./pages/repricing-rules/create-edit/index.vue'),
			props: true,
			meta: {
				title: t('products.edit-repricing-rule'),
			},
		},
		{
			path: 'create',
			component: () => import('./pages/product-editor/index.vue'),
			meta: {
				title: t('products.product-setup-and-listing'),
				can: async () => {
					const limitationStore = useLimitationsStore();

					try {
						await limitationStore.checkLimitation(abilities.CreateProduct);
						return true;
					} catch (error) {
						return false;
					}
				},
			},
		},
		{
			path: 'update/:id',
			component: () => import('./pages/product-editor/index.vue'),
			props: true,
			meta: {
				title: t('products.product-setup-and-listing'),
			},
		},
	],
};

export { productsModuleRoutes };
